<router-outlet></router-outlet>

<!-- Global Loading Component -->
<app-loading></app-loading>

<!-- Global Modal Container -->
<app-modal-container></app-modal-container>

